export default {
  state: {
    visibility: false
  },
  mutations: {
    SET_MESSAGE_CARD_VISIBILITY(state, payload) {
      state.visibility = payload
    }
  }
}
